import { useHttpClient } from "../http-client";
import { useSupervisorMode } from "../../components/supervisor-mode-provider";
import { useQuery } from "@tanstack/react-query";
import { ApiTheme } from "../types/api-theme";

export const useGetThemesApi = (params: {
  organizationId: string;
  themeStructureId?: string;
}) => {
  const httpClient = useHttpClient();
  const isSupervisor = useSupervisorMode();

  const getThemes = async ({
    signal,
  }: {
    signal: AbortSignal;
  }): Promise<ApiTheme[]> => {
    const response = await httpClient.get(`/classifier/themes`, {
      params: {
        organization_id: params.organizationId,
        theme_structure_id: params.themeStructureId,
        supervisor: isSupervisor,
      },
      signal,
    });
    return response.data.data;
  };

  return useQuery({
    queryKey: [
      "themes",
      params.organizationId,
      params.themeStructureId,
      isSupervisor,
    ],
    queryFn: getThemes,
    staleTime: Infinity,
  });
};
